// extracted by mini-css-extract-plugin
export default {"text":"Text_text__LvR0S","found":"Text_found__LfhWZ"};